import axiosClient from "../axiosClient";
import { StarredQuestion } from "../types";

export type ToggleStarResponse = {
  starredQuestion: StarredQuestion | null;
  message: string;
};

export async function toggleStarQuestion(
  questionId: number,
): Promise<ToggleStarResponse> {
  const response = await axiosClient.post(`/questions/${questionId}/star`);
  const responseData: ToggleStarResponse = response.data;
  return responseData;
}
